import { createMessageStart } from './createMessageSagas';
import { all, takeEvery } from 'redux-saga/effects';
import { EDemandActionTypes } from '@cian/demand-trap-widget';

export function* demandSagas() {
  yield all([takeEvery(EDemandActionTypes.REQUEST_CREATING_MESSAGE_START, createMessageStart)]);
}
